import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// import Checkbox from "components/library/Checkbox";

import styles from "./TrendingTopicsRow.css";

export default function TrendingTopicsRow(props) {
  const { tag } = props;

  return (
    <div
      className={classNames(styles.root, {
        [styles.disabled]: props.disabled,
        [styles.selected]: props.selected,
      })}
      // onClick={onChange}
    >
      {/* <Checkbox
        label={tag.name}
        onChange={onChange}
        className={styles.name}
        labelClassName={styles.label}
        isChecked={selected}
        isDisabled={disabled}
      /> */}

      <span className={styles.name}>{tag.name}</span>
      <span className={styles.col}>
        +{tag.recent_stories} {tag.recent_stories == 1 ? "story" : "stories"}
      </span>
      {props.trending && <span className={styles.col}>#{props.index + 1}</span>}
    </div>
  );
}

PropTypes.defaultProps = {
  selected: false,
};

TrendingTopicsRow.propTypes = {
  tag: PropTypes.shape({
    name: PropTypes.string.isRequired,
    recent_stories: PropTypes.number,
  }).isRequired,
  trending: PropTypes.bool,
  index: PropTypes.number,
  selected: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
